import React from 'react'
import styled, { keyframes } from 'styled-components'
import ImgIX from 'src/components/common/ImgIX'
import { colors } from 'src/constants/marketing-ds'

const slideUp = keyframes`
    0% {
        opacity: 0;
        transform: translateY(90px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
`

const Channel = ({ channel }) => {
  let { stationId, logoOnWhite } = channel
  let { id, logoOnWhiteUrl, name, callSign } = channel
  // const channelRouter = new ContentRouter(channel)
  // const channelDetailURL = channelRouter.getContentRoute()

  return (
    <SectionListItem key={stationId || id}>
      {/* <a href={channelDetailURL} target="_blank"> */}
      {logoOnWhite || logoOnWhiteUrl ? (
        <ImgIX imgSrc={logoOnWhite || logoOnWhiteUrl} isCompress={true} w={70} h={35} alt={name} />
      ) : (
        <span className="channel-name">{name}</span>
      )}
      {/* </a> */}
    </SectionListItem>
  )
}

export default Channel

const SectionListItem = styled.li`
  width: 86px;
  height: 40px;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  animation: 0.5s ${slideUp} ease;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .channel-name {
    font-size: 10px;
    font-weight: 600;
    color: ${colors.semantic.text.inverse};
    text-transform: uppercase;
    text-align: center;
    line-height: 1.2;
  }
`
